export const currencyFormatter = (value) => {
    return new Intl.NumberFormat().format(value)
}
